import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import TabPanel from "@mui/lab/TabPanel";
import { Grid, Paper } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { userServices } from "../../../../../../service/UserService";
import SQCFormList from "./SQCFormList";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import DomaineParTypeList from "./DomaineParTypeList";

export default function SQCFormPage() {
  const [userInfo, setUserInfo] = React.useState({});
  const location = useLocation();
  const [loadUserInfo, setLoadUserInfo] = React.useState(false);
  const [tabsChargee, setTabChargee] = React.useState([]);
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const tab_value = query.get("tab") || "0";

  const createContenus = (userInfo) => {
    const tabs = [
      {
        title: "Formulaires",
        content: <SQCFormList />,
        icon: <ListAltOutlinedIcon />,
        idx: "1",
      },
      {
        title: "Domaine par AMI",
        content: <DomaineParTypeList />,
        icon: <ListAltOutlinedIcon />,
        idx: "1",
      },
    ];

    return tabs;
  };

  const handleFetchUserInfo = (tabs = true) => {
    const curr_tab = "0";
    setLoadUserInfo(true);
    userServices
      .getMyProfile()
      .then((res) => {
        if (res && res.success) {
          setUserInfo(res.data);
          setTabChargee((prev) => [...prev, curr_tab]);
        }
      })
      .finally(() => {
        setLoadUserInfo(false);
      });
  };

  React.useEffect(() => {
    handleFetchUserInfo();
  }, []);

  const handleChange = (event, newValue) => {
    query.set("tab", newValue);
    navigate(`?${query.toString()}`);
  };

  const [contenus, setContenus] = React.useState([]);

  React.useEffect(() => {
    setContenus(createContenus(userInfo));
  }, [userInfo]);

  return (
    <Grid container justifyContent="center" spacing={2} sx={{ mb: 2 }}>
      <Grid item xs={12} md={11} lg={10}>
        <Paper elevation={1} sx={{ minHeight: "30vh" }}>
          <TabContext value={tab_value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
                variant="scrollable"
                scrollButtons="auto"
              >
                {contenus.map((item, index) => (
                  <Tab
                    key={index}
                    label={item.title}
                    icon={item.icon}
                    iconPosition="start"
                    value={index.toString()}
                  />
                ))}
              </TabList>
            </Box>
            <Grid item>
              {contenus.map((item, index) => (
                <TabPanel key={index} value={index.toString()}>
                  {item.content}
                </TabPanel>
              ))}
            </Grid>
          </TabContext>
        </Paper>
      </Grid>
    </Grid>
  );
}
